"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValue = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireDefault(require("react"));
var _colors = require("../../../constants/colors");
var _token = require("../../token");
const StyledMultiValueToken = (0, _styled.default)(_token.Token)`
    margin-right: 4px;
    margin-top: 6px;
`;
const MultiValue = props => {
  return /*#__PURE__*/_react.default.createElement(StyledMultiValueToken, {
    className: props.className,
    isDisabled: props.isDisabled,
    onCloseSelected: props.removeProps.onClick,
    onMouseDown: props.removeProps.onMouseDown,
    color: {
      backgroundColor: _colors.visBlueLight10,
      textColor: _colors.neutralDark40
    }
  }, props.children);
};
exports.MultiValue = MultiValue;
//# sourceMappingURL=MultiValue.js.map